/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Title_LeadInputs */

const en_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach Mark`)
};

const es_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunícate directamente`)
};

const de_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie Mark`)
};

const zh_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直接联系 Mark。`)
};

const ar_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل مع Mark`)
};

const fr_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez Mark`)
};

const vi_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ trực tiếp`)
};

const sw_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfikie Mark`)
};

const th_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อ Mark โดยตรง`)
};

const bs_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktirajte Marka`)
};

const ja_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markに直接ご連絡ください。`)
};

const ko_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark에게 직접`)
};

const pt_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fale diretamente`)
};

const it_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta Mark`)
};

const sv_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta Mark`)
};

const nl_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem direct contact op`)
};

const da_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Mark`)
};

const nb_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Mark`)
};

const fi_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const pl_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się`)
};

const ru_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с тренером Mark`)
};

const tr_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark'a`)
};

const hi_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark से सीधे`)
};

const id_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Mark`)
};

const ms_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Mark`)
};

const cs_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte Marka`)
};

const el_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε απευθείας`)
};

const he_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר עם Mark`)
};

const af_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak Mark`)
};

const hu_contact_title_lead = /** @type {(inputs: Contact_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépjen kapcsolatba`)
};

/**
* | output |
* | --- |
* | "Reach Mark" |
*
* @param {Contact_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_title_lead = /** @type {((inputs?: Contact_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_title_lead(inputs)
	if (locale === "de") return de_contact_title_lead(inputs)
	if (locale === "zh") return zh_contact_title_lead(inputs)
	if (locale === "ar") return ar_contact_title_lead(inputs)
	if (locale === "fr") return fr_contact_title_lead(inputs)
	if (locale === "vi") return vi_contact_title_lead(inputs)
	if (locale === "sw") return sw_contact_title_lead(inputs)
	if (locale === "th") return th_contact_title_lead(inputs)
	if (locale === "bs") return bs_contact_title_lead(inputs)
	if (locale === "ja") return ja_contact_title_lead(inputs)
	if (locale === "ko") return ko_contact_title_lead(inputs)
	if (locale === "pt") return pt_contact_title_lead(inputs)
	if (locale === "it") return it_contact_title_lead(inputs)
	if (locale === "sv") return sv_contact_title_lead(inputs)
	if (locale === "nl") return nl_contact_title_lead(inputs)
	if (locale === "da") return da_contact_title_lead(inputs)
	if (locale === "nb") return nb_contact_title_lead(inputs)
	if (locale === "fi") return fi_contact_title_lead(inputs)
	if (locale === "pl") return pl_contact_title_lead(inputs)
	if (locale === "ru") return ru_contact_title_lead(inputs)
	if (locale === "tr") return tr_contact_title_lead(inputs)
	if (locale === "hi") return hi_contact_title_lead(inputs)
	if (locale === "id") return id_contact_title_lead(inputs)
	if (locale === "ms") return ms_contact_title_lead(inputs)
	if (locale === "cs") return cs_contact_title_lead(inputs)
	if (locale === "el") return el_contact_title_lead(inputs)
	if (locale === "he") return he_contact_title_lead(inputs)
	if (locale === "af") return af_contact_title_lead(inputs)
	if (locale === "hu") return hu_contact_title_lead(inputs)
	return en_contact_title_lead(inputs)
});